import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { RentModel } from 'types/api'
import { BaseResponse } from 'types/utils'

export const rentsQueryKey = ['rents']

/**
 * Rents of one offer, newest first. The endpoint pages by `limit`/`offset`
 * (10 by default); `limit: -1` returns all of them, for callers that need
 * the whole list rather than a page.
 */
export function useRent({
  id,
  limit,
  offset
}: {
  id?: string
  limit?: number
  offset?: number
}) {
  async function getRents() {
    const rents = await apiClient.get<BaseResponse<RentModel>>(
      `${SNA_PREFIX}rents/${id}`,
      { params: { limit, offset } }
    )

    return rents.data
  }

  return useQuery({
    queryFn: getRents,
    queryKey: [...rentsQueryKey, id, { limit, offset }],
    enabled: !!id
  })
}
